import { useContext } from "react";

import styled from "styled-components";
import Context from "../../../Context";

const InfoBox = styled.section`
  cursor: pointer;
  transition: 0.25s ease-in-out;
  border: 1px solid;
  /* color: var(--element); */
  padding: 20px 20px;
  /* max-width: 80vw; */
  margin: auto;
  width: 100%;
  display: flex;
  border-radius: 20px;
  flex-direction: row;
  justify-content: flex-start;
  /* justify-content: center; */
  align-items: center;
  gap: 15px;

  &.active {
    box-shadow: 0 5px 0px 0px var(--element);
    border: 1px solid var(--element) !important;
    color: var(--element);
    transform: scale(0.95);
  }

  &.inactive {
    transform: scale(0.9);
    opacity: 0.65;
    color: var(--elementDim);
  }
`;

const Name = styled.div`
  color: var(--element);
  font-size: 12px;
  font-weight: 700;
`;

const IconImage = styled.img`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  height: 35px;
  width: 35px;
  object-fit: contain;
`;

export default function NgoTypeCard({ item, value, onChange }) {
  const { colorMode } = useContext(Context);

  return (
    <InfoBox
      className={`${value == item.value ? "active" : "inactive"}`}
      onClick={onChange(item.value)}
    >
      <IconImage
        src={item.image}
        style={{ filter: `invert(${colorMode == "DARK" ? "1" : "0"})` }}
      ></IconImage>

      <Name>{item.label}</Name>
    </InfoBox>
  );
}
